import React from "react";
import PageLayout from "../../layouts/PageLayout";
import { Heading } from "../../components/elements";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

export default function Tut() {
    return (
        <PageLayout>
          <Helmet>
            <title>Free Blockchain Course</title>
            <meta name="description" content="Step-by-step course to build and launch your own crypto project. Learn token creation, airdrops, and more—no coding required!" />
            <meta name="keywords" content="React, SEO, Web Development, Meta Tags" />
            <meta name="author" content="0xFactory" />

            {/* Open Graph (for Facebook, LinkedIn, etc.) */}
            <meta property="og:title" content="Free Blockchain Course" />
            <meta property="og:description" content="Step-by-step course to build and launch your own crypto project. Learn token creation, airdrops, and more—no coding required!" />
            <meta property="og:image" content="https://i.ibb.co/3YGHzKfZ/course.png" />
            <meta property="og:url" content="https://0xfactory.com/video-tutorials" />
            <meta property="og:type" content="website" />

            {/* Twitter Card (for Twitter sharing) */}
            <meta name="twitter:title" content="Free Blockchain Course" />
            <meta name="twitter:description" content="Step-by-step course to build and launch your own crypto project. Learn token creation, airdrops, and more—no coding required!" />
            <meta name="twitter:image" content="https://i.ibb.co/3YGHzKfZ/course.png" />
            <meta name="twitter:card" content="crypto_course" />
          </Helmet>
            <Container fluid>
                <Heading as="h2" className="mc-overview-title">Blockchain Course</Heading>
                    <Row xs={1} sm={2} xl={2}>
                            <Col xs={12} sm={12} xl={12}>

                                <div>
                                  Master the skills to launch tokens, airdrops, ico prealse project and more...
                                </div>
                                <div>
                                  Step-by-step course to build and launch your own crypto project. Learn token creation, airdrops, ico presale, and more—no coding required!
                                </div>
                                <br/>
                                <br/>

                                <div className="text-center">
                                    <h2>1- Create Token in 1 Minute</h2>
                                </div>
                                <br/>
                                <div className="text-center">
                                    <iframe width="560" height="315" src="https://www.youtube.com/embed/RP1OTIqOVRE?si=Ht4hDVOlPvUjhHX9" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                                </div>

                                <br/>
                                <br/>
                                <div className="text-center">
                                    <h2>2- Create ICO Presale Website</h2>
                                </div>
                                <br/>
                                <div className="text-center">
                                    <iframe width="560" height="315" src="https://www.youtube.com/embed/7xclaXWW2ZY?si=qRCt8POfZLQbduMB" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                                </div>

                                <br/>
                                <br/>
                                <div className="text-center">
                                    <h2>3- Create Token Airdrop Website</h2>
                                </div>
                                <br/>
                                <div className="text-center">
                                    <iframe width="560" height="315" src="https://www.youtube.com/embed/fu06pJd63BE?si=IwOTTC5SwDrFvjZ4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                                </div>

                                <br/>
                                <br/>
                                <div className="text-center">
                                    <h2>4- Create a Crypto Website</h2>
                                </div>
                                <br/>
                                <div className="text-center">
                                    <iframe width="560" height="315" src="https://www.youtube.com/embed/66aCkL76CZI?si=tme8dDF0u3op2Exh" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                                </div>

                                <br/>
                                <br/>
                                <div className="text-center">
                                    <h2>5- Create Stable Coin Like USDT</h2>
                                </div>
                                <br/>
                                <div className="text-center">
                                    <iframe width="560" height="315" src="https://www.youtube.com/embed/C3-IpHbs1cg?si=wFjM-YfXqbzrYXNd" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                                </div>

                                <br/>
                                <br/>
                                <div className="text-center">
                                    <h2>6- How to Fork PancakeSwap</h2>
                                </div>
                                <br/>
                                <div className="text-center">
                                    <iframe width="560" height="315" src="https://www.youtube.com/embed/vR8lEOOn3aE?si=7L5GX7Rj6In7iWaJ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                                </div>

                            </Col>
                    </Row>
                </Container>
        </PageLayout>
    )
}
